var map = {
	"./amplify-amazon-button_5.entry.js": [
		11074,
		74
	],
	"./amplify-auth-container.entry.js": [
		69071,
		71
	],
	"./amplify-auth-fields_9.entry.js": [
		33741,
		741
	],
	"./amplify-authenticator.entry.js": [
		24611,
		611
	],
	"./amplify-button_3.entry.js": [
		5987,
		987
	],
	"./amplify-chatbot.entry.js": [
		81012,
		12
	],
	"./amplify-checkbox.entry.js": [
		62892,
		892
	],
	"./amplify-confirm-sign-in_7.entry.js": [
		97655,
		655
	],
	"./amplify-container.entry.js": [
		61436,
		436
	],
	"./amplify-federated-buttons_2.entry.js": [
		8515,
		515
	],
	"./amplify-federated-sign-in.entry.js": [
		13269,
		269
	],
	"./amplify-form-field_4.entry.js": [
		18100,
		100
	],
	"./amplify-greetings.entry.js": [
		71717,
		717
	],
	"./amplify-icon-button.entry.js": [
		59679,
		679
	],
	"./amplify-icon.entry.js": [
		8469,
		469
	],
	"./amplify-link.entry.js": [
		81879,
		879
	],
	"./amplify-nav_2.entry.js": [
		43120,
		120
	],
	"./amplify-photo-picker.entry.js": [
		50208,
		208
	],
	"./amplify-picker.entry.js": [
		97016,
		16
	],
	"./amplify-radio-button_3.entry.js": [
		99007,
		7
	],
	"./amplify-s3-album.entry.js": [
		22440,
		440
	],
	"./amplify-s3-image-picker.entry.js": [
		2890,
		890
	],
	"./amplify-s3-image.entry.js": [
		99958,
		958
	],
	"./amplify-s3-text-picker.entry.js": [
		72157,
		157
	],
	"./amplify-s3-text.entry.js": [
		6889,
		889
	],
	"./amplify-select-mfa-type.entry.js": [
		44580,
		580
	],
	"./amplify-sign-in-button.entry.js": [
		33295,
		295
	],
	"./amplify-tooltip.entry.js": [
		18604,
		604
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 56609;
module.exports = webpackAsyncContext;